// app/javascript/packs/application.js
import ReactOnRails from "react-on-rails";
import HelloWorld from "../bundles/HelloWorld/components/HelloWorld";
import HelloWorldApp from "../startup/HelloWorldApp";
import Chat from "../bundles/Chat/components/Chat";
import ChatList from "../bundles/Chat/components/ChatList";
import StoryTellingChat from "../bundles/Chat/components/StoryTellingChat";
import ImageSection from "../bundles/Chat/components/ImageSection";
import ImageCreation from "../bundles/Chat/components/ImageCreation";
import KidFriendlyImageCreation from "../bundles/Chat/components/KidFriendlyImageCreation";
import ImageGrid from "../bundles/Shared/components/ImageGrid";
import ImageMosaic from "../bundles/Shared/components/ImageMosaic";
import StripeWrapper from "../bundles/Shared/components/StripeWrapper";
import Spinner from "../bundles/Chat/components/Spinner";
import UserMessage from "../bundles/Chat/components/UserMessage";
import AssistantMessage from "../bundles/Chat/components/AssistantMessage";
import WordList from "../bundles/Words/components/WordList";
import WordTest from "../bundles/Words/components/WordTest";
import WordListContainer from "../bundles/Words/components/WordListContainer";
import Listeners from "./listeners";
import "./phrase_levels";
import "./english_level_test";
import "./irregular_verbs";
import "./script_trainers";
import LogrocketWrapper from "../bundles/Shared/components/LogrocketWrapper";
import UsernameValidator from "../bundles/Shared/components/UsernameValidator";
import MemoryForm from "../bundles/Shared/components/MemoryForm";
import LearningWorld from "../bundles/LearningWorld/components/LearningWorld";
import CoinDisplay from "../bundles/CoinDisplay/components/CoinDisplay";
import AdventureStoryApp from '../bundles/AdventureStory/components/AdventureStoryApp';
import AdventureStoryPageIllustration from '../bundles/Shared/components/AdventureStoryPageIllustration';
import StoryBook from '../bundles/AdventureStory/components/StoryBook';
import CreateStoryFlow from '../bundles/AdventureStory/components/CreateStoryFlow';
import WorkbookQuiz from '../bundles/SummerWorkbook/components/WorkbookQuiz';
import QuizTaker from '../bundles/Quiz/components/QuizTaker';
import JumpingGame from '../bundles/JumpingGame/components/JumpingGame';
import GameWrapper from '../bundles/JumpingGame/components/GameWrapper';
import SpellingOnboarding from '../bundles/Words/components/SpellingOnboarding';
import VisualWordQuiz from '../bundles/Words/components/VisualWordQuiz';
import WordLadderQuiz from '../bundles/Words/components/WordLadderQuiz';
import WordBank from '../bundles/Words/components/WordBank';
import CharacterCreator from '../bundles/Characters/components/CharacterCreator';
ReactOnRails.register({
  HelloWorld,
  HelloWorldApp,
  Chat,
  ChatList,
  StoryTellingChat,
  ImageSection,
  ImageCreation,
  KidFriendlyImageCreation,
  ImageGrid,
  ImageMosaic,
  StripeWrapper,
  Spinner,
  WordList,
  WordTest,
  WordListContainer,
  Listeners,
  UserMessage,
  AssistantMessage,
  LogrocketWrapper,
  UsernameValidator,
  MemoryForm,
  LearningWorld,
  CoinDisplay,
  AdventureStoryApp,
  AdventureStoryPageIllustration,
  StoryBook,
  CreateStoryFlow,
  WorkbookQuiz,
  QuizTaker,
  JumpingGame,
  GameWrapper,
  SpellingOnboarding,
  VisualWordQuiz,
  WordLadderQuiz,
  WordBank,
  CharacterCreator,
});
